import { render, staticRenderFns } from "./actividad-testimonio-ars.vue?vue&type=template&id=405207c9&"
import script from "./actividad-testimonio-ars.component.ts?vue&type=script&lang=ts&"
export * from "./actividad-testimonio-ars.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports